import { WebPlugin } from '@capacitor/core';
export class WebviewPrintWeb extends WebPlugin {
    async print(options) {
        const documentTitleTemp = document.title;
        document.title = options.name;
        window.onafterprint = () => (document.title = documentTitleTemp);
        return window.print();
    }
}
//# sourceMappingURL=web.js.map